/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconPhoto16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPhoto16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 11.666A3.333 3.333 0 1 0 8 5a3.333 3.333 0 0 0 0 6.666Zm2-3.333a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.068 3.421c-.873.291-1.31.437-1.648.686-.45.331-.786.796-.958 1.329-.129.4-.129.976-.129 1.897V10c0 1.242 0 1.863.203 2.354.27.653.79 1.172 1.443 1.443C3.47 14 4.09 14 5.333 14h5.333c1.243 0 1.864 0 2.354-.203a2.667 2.667 0 0 0 1.443-1.444c.203-.49.203-1.11.203-2.353V7.333c0-.92 0-1.498-.129-1.897a2.667 2.667 0 0 0-.958-1.33c-.431-.317-.969-.48-1.49-.64-.143-.044-.285-.087-.423-.133a12.786 12.786 0 0 1-.157-.33c-.167-.36-.34-.731-.602-1.02a2 2 0 0 0-.93-.574c-.268-.076-.567-.076-1.165-.076H7.187c-.598 0-.896 0-1.164.076a2 2 0 0 0-.93.575c-.188.205-.322.473-.59 1.007l-.17.342-.265.088Zm6.235.167.418.835.789.263c.962.321 1.151.4 1.28.495.225.166.393.398.479.664.048.152.064.474.064 1.488V10c0 .64 0 1.052-.022 1.368-.021.304-.056.42-.08.475a1.333 1.333 0 0 1-.721.722c-.056.023-.171.058-.475.08-.316.02-.73.021-1.369.021H5.333c-.64 0-1.052 0-1.368-.022-.304-.02-.42-.056-.476-.08a1.333 1.333 0 0 1-.721-.72c-.023-.056-.059-.172-.08-.476A22.548 22.548 0 0 1 2.667 10V7.333c0-1.014.016-1.336.065-1.488.086-.266.253-.498.479-.664.128-.094.318-.174 1.28-.495l.789-.263.417-.835c.303-.606.348-.669.381-.705a.667.667 0 0 1 .31-.191c.047-.014.123-.026.8-.026h1.625c.678 0 .754.012.8.026.12.034.227.1.31.191.033.036.078.099.381.705Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconPhoto24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPhoto24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 17.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm3-5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.103 5.132c-1.31.437-1.965.655-2.473 1.028a4 4 0 0 0-1.437 1.994C2 8.754 2 9.62 2 11v4c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.165C5.204 21 6.136 21 8 21h8c1.864 0 2.796 0 3.53-.305a4 4 0 0 0 2.165-2.164C22 17.796 22 16.864 22 15v-4c0-1.38 0-2.247-.193-2.846a4 4 0 0 0-1.438-1.994c-.647-.476-1.453-.722-2.235-.96-.214-.066-.427-.131-.634-.2-.08-.16-.157-.327-.235-.494-.252-.542-.51-1.098-.905-1.53a3 3 0 0 0-1.394-.862C14.564 2 14.116 2 13.219 2H10.78c-.896 0-1.345 0-1.747.114a3 3 0 0 0-1.394.862c-.282.309-.483.71-.884 1.512L6.5 5l-.397.132Zm9.352.25.627 1.253 1.183.395c1.443.48 1.728.6 1.92.742a2 2 0 0 1 .718.997c.074.227.097.71.097 2.231v4c0 .96-.001 1.578-.033 2.052-.031.457-.085.63-.12.713a2 2 0 0 1-1.082 1.083c-.083.034-.256.088-.713.119-.474.032-1.093.033-2.052.033H8c-.96 0-1.579-.001-2.052-.033-.456-.031-.63-.085-.713-.12a2 2 0 0 1-1.083-1.082c-.034-.083-.087-.256-.119-.713C4.001 16.578 4 15.96 4 15v-4c0-1.521.023-2.004.097-2.231a2 2 0 0 1 .718-.997c.192-.142.477-.261 1.92-.742l1.183-.395.627-1.253c.455-.91.522-1.003.57-1.057a1 1 0 0 1 .466-.287c.07-.02.184-.038 1.2-.038h2.438c1.016 0 1.13.018 1.2.038a1 1 0 0 1 .465.287c.05.054.116.148.57 1.057Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconPhoto = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPhoto(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconPhoto16 {...iconProps} />;
        case '24':
            return <IconPhoto24 {...iconProps} />;
        default:
            return <IconPhoto24 {...iconProps} />;
    }
});
